import { GedFichier } from './ged-fichier.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DashboardGed {
    static jsonMap = {
        newsletters: { key: 'newsletters', converter: new (ArrayClassConverterFactory.build(GedFichier))(), optional: true, default: () => [] },
        documents: { key: 'documents', converter: new (ArrayClassConverterFactory.build(GedFichier))(), optional: true, default: () => [] }
    };

    newsletters: GedFichier[];
    documents: GedFichier[];
}
